export const css = {
	root: '_2ySuMTgh',
	item: '_3ULtoxjF',
	complete: '_2UDuvfg9',
	readtime: '_3vjTnE_Z',
	indented: 'FOexJICe',
	leaf: 'n2PKhMJA',
	leafItem: '_1HCMD6_E',
	treeRoot: '_3EmqnT_G',
	treeNode: '_3L8NKv3h',
	contentWrapper: '_1Xpxw-Rr',
	content: 'HgA0uDmI',
	title: '_3CpU5rE6',
	expander: 'SJS3eIjR',
	video: '_1nZtelEE',
	' _key': 'apic-theme/apic/table-of-contents/toc'
};

export default css;
